import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import api from "../../lib/api";
import { fmt, rd } from "./fniShared";

const COLS = [["cliente", "Cliente"], ["sucursal", "Sucursal"], ["marca", "Marca"], ["modelo", "Modelo"], ["banco", "Banco"],
              ["estatus_banco", "Estatus banco"], ["ejecutivo", "Ejecutivo"], ["campana", "Campaña"], ["fecha", "Fecha"], ["monto_est", "RD$ est."]];
const STAGE_LABEL = { oportunidad: "Oportunidades", sometido: "Sometidas", aprobado: "Aprobadas", firmado: "Firmadas",
                      desestimado: "Desestimadas", rechazado: "Rechazadas", en_espera: "En espera de respuesta" };

function toCSV(rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  return [COLS.map((c) => c[1]).join(","), ...rows.map((r) => COLS.map(([k]) => esc(r[k])).join(","))].join("\n");
}

export default function FniClientsTable({ pick, params, onClose }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!pick) return;
    setData(null);
    api.get("/fni/clients", { params: { ...params, ...pick } }).then((r) => setData(r.data)).catch(() => setData({ total: 0, rows: [] }));
  }, [pick, params]);
  if (!pick) return null;
  const title = `${STAGE_LABEL[pick.stage] || pick.stage}${pick.sucursal ? ` · ${pick.sucursal}` : ""}${pick.marca ? ` · ${pick.marca}` : ""}`;
  const download = () => {
    const blob = new Blob(["\ufeff" + toCSV(data.rows)], { type: "text/csv;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `fni_clientes_${pick.stage}.csv`;
    a.click();
  };
  return (
    <section className="surface p-4 mb-5 min-w-0" data-testid="fni-clients">
      <div className="flex items-center justify-between gap-2 mb-3 flex-wrap">
        <h3 className="font-display font-extrabold text-base" data-testid="fni-clients-title">
          Clientes · {title} {data && <span className="text-gray-400 text-sm">({fmt(data.total)})</span>}
        </h3>
        <div className="flex gap-2">
          <button className="btn flex items-center gap-1" onClick={download} disabled={!data?.rows?.length} data-testid="fni-clients-export">
            <Download size={14}/> CSV
          </button>
          <button className="btn flex items-center gap-1" onClick={onClose} data-testid="fni-clients-close"><X size={14}/> Cerrar</button>
        </div>
      </div>
      {!data ? <div className="spinner" style={{ borderColor: "#11182733", borderTopColor: "#111827" }}/> : (
        <div className="overflow-auto max-h-[420px]">
          <table className="w-full text-[12px]">
            <thead className="sticky top-0 bg-white">
              <tr className="text-[10px] uppercase tracking-wider text-gray-400 border-b">
                {COLS.map(([k, l]) => <th key={k} className={`py-2 px-1.5 font-extrabold ${k === "monto_est" ? "text-right" : "text-left"}`}>{l}</th>)}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r, i) => (
                <tr key={i} className="border-b border-gray-50" data-testid={`fni-client-row-${i}`}>
                  {COLS.map(([k]) => (
                    <td key={k} className={`py-1.5 px-1.5 ${k === "monto_est" ? "text-right tabular-nums whitespace-nowrap" : ""} ${k === "cliente" ? "font-bold" : "text-gray-600"}`}>
                      {k === "monto_est" ? rd(r[k]) : r[k] || "—"}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
          {data.total > data.rows.length && <div className="text-[11px] text-gray-400 mt-2">Mostrando {fmt(data.rows.length)} de {fmt(data.total)}</div>}
        </div>
      )}
    </section>
  );
}
